import {
	INSIGHT_SUBSCRIPTIONS,
	PLANT_SUBSCRIPTIONS,
} from '@innovyze/shared-utils';
import {
	AuthType,
	getAuthenticationProvider,
	useIsFeatureEnabled,
	RegisteredApplications,
	SecondaryNavItem,
	selectApplicationName,
	useHasSubscription,
	useIsAdmin,
} from '@innovyze/stylovyze';
import { useSelector } from 'react-redux';

import { FLAGS } from '@Types/flags';
import { tabs } from '.';
import { integrationTabs } from '../../../features/IntegrationsTab/routes/integrationTabs';
import { TFunc } from '../../../i18n/types';
import {
	mapManagementTabs,
	sensorGroupingTabs,
	stationTabs,
	userManagementPages,
} from './tabs';

const {
	generalSettingsPages,
	sensorConfigurationsPages,
	systemConnectionsPages,
	valueMappingTabConfigPages,
	zeroTouchImplementationPages,
} = tabs;

export const useMapManagementTabs = () => {
	const isMapManagementEnabled = useIsFeatureEnabled(FLAGS.MAP_MANAGEMENT);
	const tabs = mapManagementTabs();

	return isMapManagementEnabled ? tabs : [];
};

export default function useTabs({ t = (arg0: string) => arg0 }: { t?: TFunc }) {
	const isAdmin = useIsAdmin();
	const hasInsightSubscription = useHasSubscription(INSIGHT_SUBSCRIPTIONS);
	const hasPlantSubscription = useHasSubscription(PLANT_SUBSCRIPTIONS);
	const hasFeatIntegrations = useIsFeatureEnabled(FLAGS.ADMIN_INTEGRATIONS);
	const applicationName = useSelector(selectApplicationName);
	const resolvedMapManagementTabs = useMapManagementTabs();

	const items: (SecondaryNavItem & { to?: string })[] = [];

	if (isAdmin) {
		items.push(...generalSettingsPages(t));

		const isAuth0 = getAuthenticationProvider() !== AuthType.Forge;

		if (isAuth0) items.push(...userManagementPages(t));
	}

	if (applicationName !== RegisteredApplications.APP_AM_MAIN) {
		if (isAdmin) {
			items.push(...systemConnectionsPages(t));
		}
		items.push(...sensorConfigurationsPages(t));
		items?.push(...valueMappingTabConfigPages(t));
		items.push(...zeroTouchImplementationPages(t));
		if (hasInsightSubscription || hasPlantSubscription) {
			items.push(...sensorGroupingTabs(t));
			items.push(...stationTabs(t));
		}
	}

	// All applications
	if (hasFeatIntegrations) {
		items.push(...integrationTabs(t));
	}

	items.push(...resolvedMapManagementTabs);

	return items;
}
